// API 配置
const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://portfolio-backend.clearzero22.workers.dev/api'

// 通用错误处理
const handleResponse = async (response: Response) => {
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Network error' }))
    throw new Error(error.error || error.message || 'Request failed')
  }
  return response.json()
}

// 项目 API
export const projectsApi = {
  // 获取所有项目
  getAll: async () => {
    const response = await fetch(`${API_BASE_URL}/projects`)
    return handleResponse(response)
  },

  // 获取单个项目
  getById: async (id: number) => {
    const response = await fetch(`${API_BASE_URL}/projects/${id}`)
    return handleResponse(response)
  },

  // 创建项目（需要管理员权限）
  create: async (project: Omit<Project, 'id' | 'created_at' | 'updated_at'>) => {
    const response = await fetch(`${API_BASE_URL}/projects`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(project)
    })
    return handleResponse(response)
  },

  // 更新项目（需要管理员权限）
  update: async (id: number, project: Partial<Project>) => {
    const response = await fetch(`${API_BASE_URL}/projects/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(project)
    })
    return handleResponse(response)
  },

  // 删除项目（需要管理员权限）
  delete: async (id: number) => {
    const response = await fetch(`${API_BASE_URL}/projects/${id}`, {
      method: 'DELETE'
    })
    return handleResponse(response)
  }
}

// 联系表单 API
export const contactApi = {
  // 提交联系表单
  submit: async (contactForm: ContactFormData) => {
    const response = await fetch(`${API_BASE_URL}/contact`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(contactForm)
    })
    return handleResponse(response)
  },

  // 获取所有联系信息（需要管理员权限）
  getAll: async () => {
    const response = await fetch(`${API_BASE_URL}/contact`)
    return handleResponse(response)
  },

  // 更新联系状态（需要管理员权限）
  updateStatus: async (id: number, status: string) => {
    const response = await fetch(`${API_BASE_URL}/contact/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status })
    })
    return handleResponse(response)
  }
}

// 健康检查 API
export const healthApi = {
  check: async () => {
    const response = await fetch(`${API_BASE_URL.replace('/api', '')}/health`)
    return handleResponse(response)
  }
}

// 类型定义
export interface Project {
  id: number
  title: string
  description: string
  tags: string // JSON stringified array
  link: string
  image: string
  created_at: string
  updated_at: string
}

export interface ContactFormData {
  name: string
  email: string
  subject?: string
  message: string
}

export interface Contact extends ContactFormData {
  id: number
  status: string
  created_at: string
}
